import { Modal } from "antd";
import useNetworkStatus from "../hooks/useNetworkStatus";

export default function InternetAlert() {
  const isOnline = useNetworkStatus();

  return (
    <Modal
      open={!isOnline}
      closable={false}
      maskClosable={false}
      footer={null}
      centered
      maskStyle={{
        backdropFilter: "blur(4px)",
      }}
    >
      <div style={{ textAlign: "center", padding: "20px" }}>
        <h2 style={{ color: "red", marginBottom: "10px" }}>
          ⚠ No Internet Connection
        </h2>
        <p>Please check your network.<br /> The app will resume once you’re back online.</p>
      </div>
    </Modal>
  );
}
